<template>
    <b-modal
        id="management-profile-teachers-add-modal"
        modal-class="apprentice-default-modal teachers-add-modal"
        :title="$t('management.add_user')"
        size="md"
        ok-only
        :ok-title="$t('common.close')"
        ok-variant="primary">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="teachersIn"
            :show-empty="true">
            <template v-slot:cell(actions)="row">
                <b-button
                    class="btn-hand-pointer btn-add-teacher"
                    v-b-tooltip.hover
                    variant="primary-icon-only"
                    :title="$t('common.add')"
                    @click="selectTeacher(row.item)">
                </b-button>
            </template>

            <template #empty="scope">
                <div class="not-found">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice">{{ $t('management.no_teachers_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-management-profile-add-teacher-component',
    props: {
        teachersIn: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            fields: [
                {
                    key: 'full_name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            storageName: `management-profile-index-${this.$authUser.id}`,
        };
    },

    methods: {
        selectTeacher(teacher) {
            this.$emit('selected-teacher', teacher);
            if (this.teachersIn.length === 1) {
                this.alert.notice(
                    this.$t('management.teachers_added'),
                    this.$t(
                        'management.there_are_no_more_teachers_to_select_you_will_be_sent_back_to_the_overview_screen',
                    ),
                );
                const self = this;
                setTimeout(function () {
                    localStorage.setItem(self.storageName, 1);
                    window.location.href = self.routes.managementProfile();
                }, 2500);
            }
        },
    },
};
</script>

<style scoped></style>
